import axios from 'axios';

const changePassword = async (oldPassword, newPassword, confirmPassword) => {
    try {
        const response = await axios.post('/account/change-password', {
            old_password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmPassword
        });
        
        return response;
    } catch (error) {
        throw error;
    }
};

export default changePassword;

